import { Category } from 'api/timesheets/categories';
import {
  CategorySummaryType,
  TimesheetReportCategorySummary,
} from 'api/timesheets/reports/types';
import { TranslationKey, useTranslation } from 'hooks/use-translation';
import { CategorySummary } from './types';

export const useCategorySummary = (
  timesheetCategorySummary: TimesheetReportCategorySummary[],
  categories: Category[],
) => {
  const otherCategoryText = useTranslation(
    'timesheets.reports.summary.category.other' as TranslationKey,
  );
  const noneCategoryText = useTranslation(
    'timesheets.reports.summary.category.none' as TranslationKey,
  );

  const totalMinutes = timesheetCategorySummary.reduce(
    (total, category) => total + category.totalMinutes,
    0,
  );

  const categoriesSummary: CategorySummary[] = timesheetCategorySummary.map(
    (category) => {
      let label = '';
      let deleted;

      if (category.type === CategorySummaryType.Top) {
        const timesheetCategory = categories.find(
          (_timesheetCategory) => _timesheetCategory.id === category.categoryId,
        );

        label = timesheetCategory?.name ?? '';
        deleted = timesheetCategory?.deleted;
      }
      if (category.type === CategorySummaryType.Other) {
        label = otherCategoryText;
      }
      if (category.type === CategorySummaryType.None) {
        label = noneCategoryText;
      }

      return {
        label,
        deleted,
        minutes: category.totalMinutes,
        percentage: (category.totalMinutes / totalMinutes) * 100,
      };
    },
  );

  return {
    categoriesSummary,
  };
};
